<template>
  <div class="tabulka FinalScreenTable" :class="TableWidth">
    <div class="tabulka__top">
      <div class="tabulka__top__nadpis">Detail info</div>
    </div>

    <div class="tabulka__body">
      <table>
        <thead>
          <td class="final-left">
            <SortButton
              row="team.name"
              type="a"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
            <span>Team name</span>
          </td>
          <td class="final-left">
            <SortButton
              row="productCountSum"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
            <span>Sold products</span>
          </td>
          <td class="final-left">
            <SortButton
              row="earnedSum"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
            <span>Earned</span>
          </td>
          <td class="final-left">
            <SortButton
              row="campaignsCostSum"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
            <span>Campaigns</span>
          </td>
          <td class="final-left">
            <SortButton
              row="dataCostSum"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
            <span>Purchased data</span>
          </td>
        </thead>
        <tr
          v-for="teamRow in sortedData"
          :key="`FinalDetailRow-${teamRow.team.id}`"
          :class="{ table__importantRow: myTeam.id === teamRow.team.id }"
        >
          <td class="important final-left">{{ teamRow.team.name }}</td>
          <td class="greenTextInfo final-left">
            {{ teamRow.productCountSum | numbersThousands | inPieces }}
          </td>
          <td class="greenTextInfo final-left">
            {{ teamRow.earnedSum | numbersThousands | inCurrency }}
          </td>
          <td class="redTextInfo final-left">
            {{ teamRow.campaignsCostSum | numbersThousands | inCurrency }}
          </td>
          <td class="redTextInfo final-left">
            {{ teamRow.dataCostSum | numbersThousands | inCurrency }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SortButton from "@/components/game/table/SortButton.vue";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js"; // obsahuje logiku k sortovani

export default {
  name: "FinalDetailInfo",
  mixins: [sortingLogicMixin],
  components: {
    SortButton,
  },
  props: {
    TableWidth: String,
  },
  data() {
    return {
      currentSortRow: "rank",
      currentSortDirection: 1,
    };
  },
  computed: {
    ...mapGetters({
      sourceData: "gameResult",
      myTeam: "myTeam",
    }),
  },
};
</script>


